import React from 'react';
import { useStaticQuery } from 'gatsby';
import { RiGithubFill, RiTwitterFill } from 'react-icons/ri';
import { Nav, NavList, NavListItem, NavLink } from './Nav';
import { ColorModeSwitcher } from './ColorModeSwitcher';
const AppNavQuery = "3442269102";
export function AppNav() {
  const data = useStaticQuery(AppNavQuery);
  return /*#__PURE__*/React.createElement(Nav, null, /*#__PURE__*/React.createElement(NavList, null, (data.site.siteMetadata.navItems || []).map((_ref, index) => {
    let {
      title,
      url
    } = _ref;
    return /*#__PURE__*/React.createElement(NavListItem, {
      key: index
    }, /*#__PURE__*/React.createElement(NavLink, {
      to: url
    }, title));
  }), data.site.siteMetadata.githubRepositoryURL ? /*#__PURE__*/React.createElement(NavListItem, null, /*#__PURE__*/React.createElement(NavLink, {
    as: "a",
    href: data.site.siteMetadata.githubRepositoryURL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(RiGithubFill, {
    style: {
      width: 24,
      height: 24
    }
  }))) : null, data.site.siteMetadata.twitterAccount ? /*#__PURE__*/React.createElement(NavListItem, null, /*#__PURE__*/React.createElement(NavLink, {
    as: "a",
    href: "https://twitter.com/" + data.site.siteMetadata.twitterAccount,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(RiTwitterFill, {
    style: {
      width: 24,
      height: 24
    }
  }))) : null, /*#__PURE__*/React.createElement(NavListItem, null, /*#__PURE__*/React.createElement(NavLink, {
    as: ColorModeSwitcher
  }))));
}